module.exports = __webpack_public_path__ + "static/media/css3.0aa19834.svg";